export default __webpack_public_path__ + "static/6660-be989ecdf5b99aa210eda60b70f4ea3a.jpg";